$(document).ready(function() {
  $('.partner-item').each(function(index, value) {
    let img = $(value).find('img');
    img.attr('src', img.attr('data-src'));
  });

  $('.partner-item').on('mouseenter', function() {
    let img = $(this).find('img');
    img.attr('src', img.attr('data-hover'));
  });

  $('.partner-item').on('mouseleave', function() {
    let img = $(this).find('img');
    img.attr('src', img.attr('data-src'));
  })
});



// WEBPACK FOOTER //
// ./scripts/wpbakery/partner-row.js